(function($) {
    $(document).ready(() => {
        const $heroCarousel = $('.hero-carousel-slick');
        if ($heroCarousel.length) {
            $heroCarousel.slick({
                fade: true,
                adaptiveHeight: true,
                arrows: false,
                dots: true,
                autoplay: true,
                autoplaySpeed: 10000,
                pauseOnHover: false,
            });
        }

        const $miniatureServices = $('[data-carousel-nav]');
        const $largeService = $('[data-service-carousel]');

        const services = document.querySelector('#services');
        function adjustCarouselWidths() {
            if (window.innerWidth < 1024) return;
            const containerWidth = services.offsetWidth - 32; // 32 is the flex gap

            for (let i = 0; i < services.children.length; i++) {
                let $carousel = $(`[data-service-carousel=${i}]`);
                let $nav = $(`[data-carousel-nav=${i}]`);

                if ($nav.length && $carousel.length) {
                    $carousel.css('max-width', `${containerWidth * 0.6}px`);
                    $nav.css('max-width', `${containerWidth * 0.4}px`);
                }
            }
        }

        if (services) {

            adjustCarouselWidths();

            window.addEventListener('resize', adjustCarouselWidths);

            for (let i = 0; i < services.children.length; i++) {
                let $carousel = $(`[data-service-carousel=${i}]`);
                let $nav = $(`[data-carousel-nav=${i}]`);

                if ($nav.length && $carousel.length) {
                    $nav.slick({
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: false,
                        focusOnSelect: true,
                        autoplay: false,
                        dots: true,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 6,
                                }
                            }
                        ]
                    });

                    $carousel.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        asNavFor: `[data-carousel-nav=${i}]`,
                    });
                }
            }

            $(`[data-carousel-nav]`).on('click', function(e) {
                const carouselId = this.getAttribute('data-carousel-nav');
                const slideId = e.target.getAttribute('data-slick-index');
                $(`[data-service-carousel=${carouselId}]`).slick('slickGoTo', slideId);
            })
        }

    });
})(jQuery);